<script lang="ts" setup>
import { computed } from 'vue';
import type { PhoneMsgVO } from '@core/types/im';
import { durationSeconds } from '@core/utils/dayjs';
import ImMsgDate from './ImMsgDate.vue';

interface Props {
  msg: PhoneMsgVO;
}

const { msg } = defineProps<Props>();

const desc = computed(() => {
  const { status, info, duration } = msg.msgBody.phoneMsg;
  if (status === 4) {
    return `${info}：${durationSeconds(duration)}`;
  } else {
    return info;
  }
});
</script>

<template>
  <div ref="txt" class="whitespace-pre-wrap break-words">
    <ImMsgDate v-if="msg.showDatetime" :time="msg.msgTime" />
    <div class="text-colorTextTertiary mb-2 text-center text-sm leading-[22px]">
      <img
        class="inline h-[14px] w-[14px]"
        src="@core/assets/image/im/icon-phone.svg"
        alt="phone"
      />
      <span class="ml-1">{{ desc }}</span>
    </div>
  </div>
</template>

<style scoped></style>
